import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../routes';

const TITLE_BY_PATH = Object.fromEntries(Object.values(ROUTES).map((r) => [r.path, r.title]));

/**
 * Every route change behaves like a fresh page load did in the original
 * multi-page build: scroll back to the top and swap the document title.
 */
export default function RouteChrome() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = TITLE_BY_PATH[pathname] || ROUTES.home.title;
  }, [pathname]);
  return null;
}
